import * as React from "react"

/**
 * Returns a safe `rel` string when `target === '_blank'`.
 * Adds `noopener noreferrer` tokens if missing. Designed to be reused
 * across call sites so the primitive can remain small and self-documenting.
 */
export function useSafeRelForTargetBlank(rel?: string, target?: string) {
  return React.useMemo(() => {
    if (target === "_blank") {
      const existing = typeof rel === "string" ? rel : ""
      const tokens = new Set(existing.split(/\s+/).filter(Boolean))
      tokens.add("noopener")
      tokens.add("noreferrer")
      return Array.from(tokens).join(" ")
    }

    return rel as string | undefined
  }, [rel, target])
}

export default useSafeRelForTargetBlank
